class cSearchModal {
    constructor(selector, show = false, hideCallback = false, showCallback = false) {
        this.modal = document.querySelector(selector);
        if (!this.modal) return;
        
        this.closeButton = this.modal.querySelector(".c-search-modal-close-button");
        this.body = document.body;
        this.html = document.querySelector("html");
        
        this.hideCallback = hideCallback;
        this.showCallback = showCallback;

        this.init();
        
        if (show) {
            this.show();
        }
    }
    
    init() {
        if (this.closeButton) {
            this.closeButton.addEventListener("click", (e) => {
                e.stopPropagation();
                this.hide();
            });
        }
    }
    
    show() {
        if (this.modal) {
            this.modal.classList.add("show");
            this.body.classList.add("body-no-scroll");
            this.html.classList.add("html-modal-open");

            if(typeof this.showCallback == 'function') {
                this.showCallback();
            }
        }
    }
    
    hide() {
        if (this.modal) {
            this.modal.classList.remove("show");
            if (!document.querySelector(".c-search-modal-overlay.show")) {
                this.body.classList.remove("body-no-scroll");
                this.html.classList.remove("html-modal-open");
            }

            if(typeof this.hideCallback == 'function') {
                this.hideCallback();
            }
        }
    }
}